module.exports = __webpack_public_path__ + "ef157392f77bd4f4c30b52d4dffa514b.png";